import { Form as Unform } from '@unform/web';

import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: calc(100vh - 4rem); 
`;

export const Form = styled(Unform)`
  display: flex;
  flex-direction: column;
  width: 380px;
  max-width: 80%;

  @media (max-width: 750px) {
    max-width: 90% !important;
   
    img {
      width: 320px !important;
    }
  }

  h2 {
    margin-top: 2rem;
  }

  p {
    width: 320px;
    max-width: 100%;
    margin: 0.5rem 0 1rem;
  }

  a {
    margin: 2rem 0;
    text-align: start;
    text-decoration: none;
    display: flex;
    align-items: center;
    color: var(--gray-800);

    svg {
      margin-right: 5px;
    }
  }

  img {
    width: 400px;
    margin-left: -20px;
  }

  button {
    background-color: var(--light-blue);

    color: white;
    border: var(--light-blue);
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: 0.3rem;
  }
`;

